// extracted by mini-css-extract-plugin
module.exports = {"root":"CreditNotesWithProcessingErrorTable_root__v_4n2","badgeForName":"CreditNotesWithProcessingErrorTable_badgeForName__sSh7d"};